function isValidDateString(dateString) {
  const timestamp = Date.parse(dateString);
  return !isNaN(timestamp);
}

export default isValidDateString;
